import { Service } from '@piwikpro/platform';

@Service()
export class InvalidRequestError extends Error {
  name = 'InvalidRequestError';

  constructor(name: string, public readonly errors: any) {
    super(name);
  }
}
